<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_27_232)">
      <path
        d="M7.87954 10.8129V10.141H4.51977V10.8129H2.50391V11.4849H9.8954V10.8129H7.87954Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.46582 9.46904V0.733643H11.9338V9.46904H0.46582ZM1.9151 3.26467L2.91468 6.10675L3.90384 3.26467H4.65874L3.25828 6.96042H2.56586L1.1602 3.26467H1.9151ZM5.75809 3.26467H6.48695L7.84575 6.96042H7.10648L6.76287 6.03908H5.47175L5.13335 6.96042H4.39408L5.75809 3.26467ZM6.63272 5.53417L6.12252 4.00902L5.59149 5.53417H6.63272ZM8.25118 3.26467V6.96042H8.96963V5.72156H9.68808L10.4482 6.96042H11.2395L10.3961 5.57061C10.6009 5.48385 10.7623 5.34158 10.8803 5.14377C11.0018 4.94597 11.0625 4.72909 11.0625 4.49311C11.0625 4.34043 11.033 4.19121 10.974 4.04546C10.9185 3.89971 10.8369 3.76785 10.7293 3.64986C10.6252 3.53187 10.5002 3.43818 10.3545 3.36878C10.2122 3.29937 10.056 3.26467 9.88591 3.26467H8.25118ZM9.87029 5.09172H8.96963V3.89451H9.83906C9.92582 3.89451 10.0057 3.92053 10.0785 3.97259C10.1549 4.02464 10.2174 4.09578 10.266 4.186C10.3146 4.27623 10.3388 4.3786 10.3388 4.49311C10.3388 4.65968 10.2937 4.80196 10.2035 4.91995C10.1167 5.03446 10.0057 5.09172 9.87029 5.09172Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_27_232">
        <rect
          width="11.468"
          height="11.468"
          fill="white"
          transform="translate(0.46582 0.375244)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
